import React from "react";
import { withRouter } from "utils/withRouter";
import { RouteComponentProps } from "utils/withRouter/types";

class ErrorBoundary extends React.PureComponent<
    RouteComponentProps,
    { error: boolean }
> {
    constructor(props: any) {
        super(props);
        this.state = {
            error: false,
        };
    }
    componentDidCatch() {
        this.setState({ error: true });
    }

    render() {
        if (this.state.error) return <p>Something went wrong</p>;
        else return <>{this.props.children}</>;
    }
}

export default withRouter(ErrorBoundary);
